import React from 'react';
import { Navigate } from 'react-router-dom';
import { useNicuInCharge } from '../hook/useNicuInCharge';

const NicuInChargeRoute = ({ component: Component, ...rest }) => {
  const { isNicuInCharge, isAdmin, isSuperAdmin, isLoading } = useNicuInCharge();
  // console.log("useNicuInCharge isNicuInCharge:", isNicuInCharge);
  // console.log("useNicuInCharge isAdmin:", isAdmin);
  // console.log("useNicuInCharge isSuperAdmin:", isSuperAdmin);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (isNicuInCharge || isAdmin || isSuperAdmin) ? <Component {...rest} /> : <Navigate to="/login" replace />;
};

export default NicuInChargeRoute;